import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { totalClicksConfig } from './../totalClicks';

export const mediaViewerClicksConfig = {
    ...totalClicksConfig,
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
